import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"
import { ZIndex } from "@/styles/theme"

const useStyles = makeStyles((theme) => ({
	popper: {
		zIndex: ZIndex.menu,
		paddingLeft: theme.spacing(1)
	},
	panel: {
		minWidth: theme.spacing(35),
		backgroundColor: colors.gray[0],
		borderRadius: "0.75rem",
		boxShadow: "0 0.25rem 1.25rem rgba(0, 0, 0, 0.12)",
		padding: theme.spacing(2)
	}
}))

export default useStyles
